export const createDataConstants = {

    CREATE_NEW_DATA_REQUEST: "CREATE_NEW_DATA_REQUEST",
    CREATE_NEW_DATA_SUCCESS: "CREATE_NEW_DATA_SUCCESS",
    CREATE_NEW_DATA_FAILURE: "CREATE_NEW_DATA_FAILURE"
};